import { render } from "./form-iran-plaque.vue?vue&type=template&id=740ac650"
import script from "./form-iran-plaque.vue?vue&type=script&lang=js"
export * from "./form-iran-plaque.vue?vue&type=script&lang=js"

import "./form-iran-plaque.vue?vue&type=style&index=0&id=740ac650&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__